// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchInterestsCard-cls1_7fA","cls2":"ResearchInterestsCard-cls2_UjI ResearchInterestsCard-cls1_7fA","altLook":"ResearchInterestsCard-altLook_e9T"};